var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useMemo } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { UserContext } from "../utils/types/user";
import { LoadingOrError } from "../components/common/LoadingOrError";
var auth0;
export var UserProvider = function (_a) {
    var children = _a.children;
    var isLoading = useAuth0().isLoading;
    var values = useMemo(function () {
        return {
            sendForgotPasswordEmail: function (email, onSendForgotPasswordEmailSuccess, onSendForgotPasswordEmailError) {
                auth0.changePassword({
                    email: email,
                    connection: "Username-Password-Authentication",
                }, function (err) {
                    if (err && onSendForgotPasswordEmailError) {
                        onSendForgotPasswordEmailError(err);
                    }
                    else {
                        onSendForgotPasswordEmailSuccess(email);
                    }
                });
            },
            resetPassword: function (email, onResetPasswordSuccessful, onResetPasswordSuccessfulError) { return __awaiter(void 0, void 0, void 0, function () {
                var resp, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, fetch("/api/resetPassword", {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({ email: email }),
                                })];
                        case 1:
                            resp = _a.sent();
                            if (resp.ok) {
                                onResetPasswordSuccessful();
                            }
                            else {
                                onResetPasswordSuccessfulError();
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            onResetPasswordSuccessfulError();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
        };
    }, []);
    return (<LoadingOrError loading={isLoading}>
      <UserContext.Provider value={values}>{children}</UserContext.Provider>
    </LoadingOrError>);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXNlclByb3ZpZGVyLmpzeCIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlVzZXJQcm92aWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0EsT0FBTyxLQUFLLEVBQUUsRUFBRSxPQUFPLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFDdkMsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLG9CQUFvQixDQUFDO0FBQzlDLE9BQU8sRUFBK0IsV0FBVyxFQUFFLE1BQU0scUJBQXFCLENBQUM7QUFFL0UsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLHFDQUFxQyxDQUFDO0FBRXJFLElBQUksS0FBYyxDQUFDO0FBRW5CLE1BQU0sQ0FBQyxJQUFNLFlBQVksR0FBc0MsVUFBQyxFQUUvRDtRQURDLFFBQVEsY0FBQTtJQUVBLElBQUEsU0FBUyxHQUFLLFFBQVEsRUFBRSxVQUFmLENBQWdCO0lBRWpDLElBQU0sTUFBTSxHQUFHLE9BQU8sQ0FBQztRQUNyQixPQUFPO1lBQ0wsdUJBQXVCLEVBQUUsVUFDdkIsS0FBYSxFQUNiLGdDQUEyQyxFQUMzQyw4QkFBc0M7Z0JBRXRDLEtBQUssQ0FBQyxjQUFjLENBQ2xCO29CQUNFLEtBQUssT0FBQTtvQkFDTCxVQUFVLEVBQUUsa0NBQWtDO2lCQUMvQyxFQUNELFVBQUMsR0FBRztvQkFDRixJQUFJLEdBQUcsSUFBSSw4QkFBOEIsRUFBRTt3QkFDekMsOEJBQThCLENBQUMsR0FBRyxDQUFDLENBQUM7cUJBQ3JDO3lCQUFNO3dCQUNMLGdDQUFnQyxDQUFDLEtBQUssQ0FBQyxDQUFDO3FCQUN6QztnQkFDSCxDQUFDLENBQ0YsQ0FBQztZQUNKLENBQUM7WUFFRCxhQUFhLEVBQUUsVUFDYixLQUFhLEVBQ2IseUJBQW1DLEVBQ25DLDhCQUFzQzs7Ozs7OzRCQUd2QixxQkFBTSxLQUFLLENBQUMsb0JBQW9CLEVBQUU7b0NBQzdDLE1BQU0sRUFBRSxNQUFNO29DQUNkLE9BQU8sRUFBRSxFQUFFLGNBQWMsRUFBRSxrQkFBa0IsRUFBRTtvQ0FDL0MsSUFBSSxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsRUFBRSxLQUFLLE9BQUEsRUFBRSxDQUFDO2lDQUNoQyxDQUFDLEVBQUE7OzRCQUpJLElBQUksR0FBRyxTQUlYOzRCQUVGLElBQUksSUFBSSxDQUFDLEVBQUUsRUFBRTtnQ0FDWCx5QkFBeUIsRUFBRSxDQUFDOzZCQUM3QjtpQ0FBTTtnQ0FDTCw4QkFBOEIsRUFBRSxDQUFDOzZCQUNsQzs7Ozs0QkFFRCw4QkFBOEIsRUFBRSxDQUFDOzs7OztpQkFFcEM7U0FDRixDQUFDO0lBQ0osQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBRVAsT0FBTyxDQUNMLENBQUMsY0FBYyxDQUFDLE9BQU8sQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUNqQztNQUFBLENBQUMsV0FBVyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxFQUFFLFdBQVcsQ0FBQyxRQUFRLENBQ3ZFO0lBQUEsRUFBRSxjQUFjLENBQUMsQ0FDbEIsQ0FBQztBQUNKLENBQUMsQ0FBQyJ9